import React, { useMemo } from 'react';
import {connect} from 'react-redux'

function ColourDisplay({stone, colours, fancyColours, fancyOvertones, fancyIntensities}) {
    const colourMap = useMemo(() => colours.reduce((map,c) => map.set(c.colour, c), new Map()))
    const fancyColourMap = useMemo(() => fancyColours.reduce((map,c) => map.set(c.fancyColour, c), new Map()))
    const overtoneMap = useMemo(() => fancyOvertones.reduce((map,o) => map.set(o.fancyOvertone, o), new Map()))
    const intensityMap = useMemo(() => fancyIntensities.reduce((map,i) => map.set(i.fancyIntensity, i), new Map()))

    if (stone == null) return null
    if (stone.colour) return colourMap.get(stone.colour)?.description ?? stone.colour
    if (stone.fancyColour) {
        let col = ''
        if (stone.fancyIntensity) col += (col.length ? ' ' : '') + (intensityMap.get(stone.fancyIntensity)?.description ?? stone.fancyIntensity)
        if (stone.fancyOvertone) col += (col.length ? ' ' : '') + (overtoneMap.get(stone.fancyOvertone)?.description ?? stone.fancyOvertone)
        if (stone.fancyColour) col += (col.length ? ' ' : '') + (fancyColourMap.get(stone.fancyColour)?.description ?? stone.fancyColours)
        col = col.replace(/ /g, '\u00A0')
        return col
    }
    return stone.colour
}

function mapStateToProps(state, ownProps) {
    return {
        colours: state.attributes.colours,
        fancyColours: state.attributes.fancyColours,
        fancyOvertones: state.attributes.fancyOvertones,
        fancyIntensities: state.attributes.fancyIntensities
    };
}

export default connect(mapStateToProps)(ColourDisplay)